export enum Role {
  STUDENT = 'STUDENT',
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  LEKO = 'LEKO', // Lernkoordination
  SCHUKO = 'SCHUKO', // Schulkoordination
  EXTERNAL_CONTACT = 'EXTERNAL_CONTACT',
  EXTERNAL_CONTACT_BUT = 'EXTERNAL_CONTACT_BUT',
  EXTERNAL_TEACHER = 'EXTERNAL_TEACHER',
  IKL = 'IKL', // Intensivkursleitung
  OSC = 'OSC', // OS-Coach (Oberstufen-Coach)
  DKL = 'DiKu', // Digitale Kursleitung
  PROGRAM_MANAGEMENT = 'PROGRAM_MANAGEMENT',
  ASSISTANT_PROGRAM_MANAGEMENT = 'ASSISTANT_PROGRAM_MANAGEMENT',
  SCHOOL_SUPPORT = 'SCHOOL_SUPPORT',
  LOGISTICS_STAFF = 'LOGISTICS_STAFF',

  // KPF = Kooperationspartner, produkt, Finanzierung/Förderung
  INTERNAL_KPF_STRATEGY = 'INTERNAL_KPF_STRATEGY',
  INTERNAL_KPF_OPERATIV = 'INTERNAL_KPF_OPERATIV',
  INTERNAL_KPF_ADMINISTRATION = 'INTERNAL_KPF_ADMINISTRATION',
  INTERNAL_KPF_BUT_OPERATIV = 'INTERNAL_KPF_BUT_OPERATIV',

  HEFTE_TEACHER = 'HEFTE_TEACHER',
  HEFTE_STUDENT = 'HEFTE_STUDENT',

  // Notification Roles
  NOTIFICATION_REGISTERED_STUDENT = 'NOTIFICATION_REGISTERED_STUDENT',
  NOTIFICATION_REGISTERED_STUDENT_PARTS_BY_MAIL = 'NOTIFICATION_REGISTERED_STUDENT_PARTS_BY_MAIL',
}
